/** Default QR branding colors for Swiss Post postcard campaigns. */
export const DEFAULT_QR_BRANDING = {
  blockColor: '#a30d65',
  textColor: '#ffffff',
} as const
